import React, { useState } from 'react';
import useManageOrder from '../../order/useManageOrder';
import OrderSummaryTable from '../../../sharedComponents/OrderSummaryTable';
import CircularProgress from '@mui/material/CircularProgress';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import DualShipDateDropdown from '../../../sharedComponents/DualShipDateDropdown';

function OrderSummary(props) {

  const location = useLocation();
  /** Multi ship-date selection: staff only (protected /admin/ordersummary route). Public /ordersummary stays single-select. */
  const allowMultiShipDate = location.pathname.startsWith('/admin/ordersummary');

  const { orders, orderSummary, isLoading, error, getOrderSummary, createSecondOrderPaymentLink } = useManageOrder()
  const [formData, setFormData] = useState({
    searchtext: '',
    shipDate: 'all',
    shipDateIds: undefined,
    multiShipType: undefined,
  })
  const [hasMore, setHasMore] = useState(false);
  const [currentOffset, setCurrentOffset] = useState(0);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const shopName = useSelector((state) => state.shop.name);

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if(formData.searchtext == ""){
      toast.error("กรุณาใส่เบอร์โทรศัพท์")
    }else if (
      allowMultiShipDate &&
      formData.shipDate === 'multi' &&
      (!formData.shipDateIds || formData.shipDateIds.length === 0)
    ) {
      toast.error('กรุณาเลือกอย่างน้อยหนึ่งรอบเมื่อใช้โหมดเลือกหลายรอบ')
    } else {
      try {
        const shop = shopName === 'tama' ? 'tama' : 'smile';
        
        // Reset pagination on new search
        setCurrentOffset(0);
        setHasMore(false);
        
        const requestData = {
          searchtext: formData.searchtext,
          shop: shop,
          shipDate: formData.shipDate,
          ...(allowMultiShipDate && formData.shipDate === 'multi'
            ? {
                shipDateIds: formData.shipDateIds,
                multiShipType: formData.multiShipType,
              }
            : {}),
          limit: 500,
          offset: 0
        };
        
        console.log('Submitting:', requestData);
        
        const result = await getOrderSummary(requestData, false)
        console.log(result)
        if(result && result.success){
          setHasMore(result.hasMore || false);
          setCurrentOffset(500);
          console.log(orders)
        }
      } catch (error) {
        
      }
    }
  };

  const handleLoadMore = async () => {
    if (isLoadingMore || !hasMore) return;
    
    setIsLoadingMore(true);
    try {
      const shop = shopName === 'tama' ? 'tama' : 'smile';
      
      const requestData = {
        searchtext: formData.searchtext,
        shop: shop,
        shipDate: formData.shipDate,
        ...(allowMultiShipDate && formData.shipDate === 'multi'
          ? {
              shipDateIds: formData.shipDateIds,
              multiShipType: formData.multiShipType,
            }
          : {}),
        limit: 500,
        offset: currentOffset
      };
      
      const result = await getOrderSummary(requestData, true);
      if (result && result.success) {
        setHasMore(result.hasMore || false);
        setCurrentOffset(currentOffset + 500);
      }
    } catch (error) {
      toast.error('เกิดข้อผิดพลาดในการโหลดข้อมูลเพิ่มเติม');
    } finally {
      setIsLoadingMore(false);
    }
  };

  const handleDataChange = (e) => {
    if (e && e.target) {
      const { name, value } = e.target
      setFormData({ ...formData, [name]: value })
    } else if (
      allowMultiShipDate &&
      e &&
      typeof e === 'object' &&
      e.shipDate === 'multi'
    ) {
      setFormData({
        ...formData,
        shipDate: 'multi',
        shipDateIds: e.shipDateIds,
        multiShipType: e.multiShipType,
      })
    } else {
      setFormData({
        ...formData,
        shipDate: e,
        shipDateIds: undefined,
        multiShipType: undefined,
      })
    }
  };

  const createTable = () => {
      // Code from your `createTable` function here
      //return result; // This will be a JSX representation of the table
  };

  return (
    <div className="xl:w-4/5 mx-auto flex flex-col items-center justify-center mt-1">
      <img className="h-64 w-64" src="https://image.makewebeasy.net/makeweb/m_1920x0/mawDVKUgN/DefaultData/Logo__1_.png?v=202305101549" alt="Logo" />
      <div className="w-full text-center">
        <form id="search-form" onSubmit={handleFormSubmit} className="mb-2 flex flex-col items-center">
          <div>
            <label htmlFor="searchtext">กรุณากรอกเบอร์โทรศัพท์ที่ต้องการค้นหา</label>
          </div>
          <div>
            <input type="text" className="pl-2 border border-gray-500 rounded" id="searchtext" name="searchtext" onChange={handleDataChange}/>
            <button type="submit" className="btn btn-blue mb-1 ml-2">ค้นหา</button>
            {isLoading && <CircularProgress />}
          </div>
          <div className='mb-4'>
            <DualShipDateDropdown
              handleDataChange={handleDataChange}
              allowMultiShipDate={allowMultiShipDate}
            />
          </div>
        </form>
        {error && <p className='text-red-600'>{error}</p>}
        <OrderSummaryTable 
          smileName={formData.searchtext}
          orders={orders} 
          orderSummary={orderSummary}
          createSecondOrderPaymentLink={createSecondOrderPaymentLink}
        />
        {hasMore && orders && orders.length > 0 && (
          <div className="mt-4 flex justify-center items-center">
            <button
              onClick={handleLoadMore}
              disabled={isLoadingMore}
              className="btn btn-blue px-6 py-2 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
            >
              {isLoadingMore && <CircularProgress size={20} />}
              {isLoadingMore ? 'กำลังโหลด...' : 'โหลดเพิ่มเติม (500 รายการ)'}
            </button>
          </div>
        )}
      </div>
    </div>
  );  
}

export default OrderSummary;
